import { type AstNode } from "./types";

export const generateQuery = (
  ast: AstNode,
  data: Record<string, string>,
): string => {
  if (ast.type === "variable") {
    return data[ast.value];
  } else if (ast.type === "number") {
    return ast.value;
  } else if (ast.type === "operator") {
    const leftOperand = generateQuery(ast.left, data);
    const rightOperand = generateQuery(ast.right, data);
    const operator = ast.value;

    if (operator === "/") {
      return `(SAFE_DIVIDE(${leftOperand}, ${rightOperand}))`;
    } else {
      return `(${leftOperand} ${operator} ${rightOperand})`;
    }
  } else {
    throw new Error("Invalid AST node type");
  }
};
